<script>
import FilterItem from './FilterItem.vue';

import ButtonNext from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import CheckBox from 'dashboard/components-next/wgpt/Form/CheckBox.vue';

export default {
  components: {
    FilterItem,
    Icon,
    ButtonNext,
    CheckBox,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      updatedValue: this.modelValue,
      allDateOptions: [
        {
          label: this.$t('WGPT_BOARDS.FILTER.DUE_DATES.OPTIONS.NO_DATES'),
          value: 'no_dates',
        },
        {
          label: this.$t('WGPT_BOARDS.FILTER.DUE_DATES.OPTIONS.OVERDUE'),
          value: 'overdue',
        },
        {
          label: this.$t('WGPT_BOARDS.FILTER.DUE_DATES.OPTIONS.DUE_NEXT_DAY'),
          value: 'due_next_day',
          group: 'due_dates',
        },
        {
          label: this.$t('WGPT_BOARDS.FILTER.DUE_DATES.OPTIONS.DUE_NEXT_WEEK'),
          value: 'due_next_week',
          group: 'due_dates',
        },
        {
          label: this.$t('WGPT_BOARDS.FILTER.DUE_DATES.OPTIONS.DUE_NEXT_MONTH'),
          value: 'due_next_month',
          group: 'due_dates',
        },
        {
          label: this.$t('WGPT_BOARDS.FILTER.DUE_DATES.OPTIONS.COMPLETE'),
          value: 'complete',
          group: 'complete',
        },
        {
          label: this.$t('WGPT_BOARDS.FILTER.DUE_DATES.OPTIONS.NOT_COMPLETE'),
          value: 'not_complete',
          group: 'complete',
        },
      ],
      showMoreOptions: false,
      limit: 3,
    };
  },
  computed: {
    dateOptions() {
      return this.allDateOptions.filter(({ value }, index) => {
        if (this.showMoreOptions || index < this.limit) return true;
        if (this.updatedValue.includes(value)) return true;
        return false;
      });
    },
  },
  watch: {
    updatedValue(value) {
      this.$emit('update:modelValue', value);
    },
    modelValue(value, valueBefore) {
      if (value.join() === valueBefore.join()) return;
      this.updatedValue = value;
    },
  },
  methods: {
    toggleCheckbox(option) {
      const group = option.group;

      if (this.updatedValue.includes(option.value)) {
        // If the option has a group, remove any previously selected value from the same group
        if (group) {
          this.updatedValue = this.updatedValue.filter(val => {
            if (option.value === val) return true;
            const selectedOption = this.allDateOptions.find(
              opt => opt.value === val
            );
            return !selectedOption || selectedOption.group !== group;
          });
        }
      }
    },
  },
};
</script>

<template>
  <div>
    <label class="text-sm mb-2 text-slate-600 dark:text-slate-400">{{
      $t('WGPT_BOARDS.FILTER.DUE_DATES.TITLE')
    }}</label>
    <FilterItem
      v-for="option in dateOptions"
      :key="option.value"
      class="group py-1.5"
    >
      <template #start>
        <CheckBox
          v-model="updatedValue"
          :value="option.value"
          @change="toggleCheckbox(option)"
        />
      </template>
      <span>{{ option.label }}</span>
    </FilterItem>

    <ButtonNext
      v-if="!showMoreOptions"
      variant="link"
      class="!ms-6 !mt-2 [&>*]:pointer-events-none"
      @click="showMoreOptions = true"
    >
      {{ $t('WGPT_BOARDS.FILTER.BUTTON_TXT.SHOW_MORE_OPTIONS') }}
      <Icon icon="i-lucide-chevron-down" class="w-4 h-4" />
    </ButtonNext>
  </div>
</template>
